// Mutation hook for DELETE /api/sites/:siteId/comms/channels/:channelId/messages/:messageId.
//
// The server soft-deletes the message and broadcasts the updated record (with
// `deletedAt`) over WS. The WS frame is the authoritative UI update — this
// hook just fires the REST call. No optimistic update needed; the round-trip
// is fast and the WS echo lands within milliseconds.

import { useMutation } from '@tanstack/react-query';
import { useClientApis } from '../../hooks/ClientApisProvider.js';

interface IDeleteMessageVars {
  channelId: string;
  messageId: string;
}

export function useDeleteMessage(siteId: string) {
  const { deleteMessage } = useClientApis().comms;
  return useMutation<{ message: unknown }, Error, IDeleteMessageVars>({
    mutationFn: ({ channelId, messageId }) =>
      deleteMessage(siteId, channelId, messageId),
  });
}
